export default "__VITE_ASSET__2e5cfbc5__"